import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { homePlugin } from '@backstage/plugin-home';

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/',
        noHeader: true,
        routeRef: homePlugin.routes.root,
        loader: () =>
          import('../components/home/HomePage').then(m => <m.HomePage />),
      },
    }),
  ],
});
